module.exports = __webpack_public_path__ + "media/images/lig/main-img-581a7ada70152910b47c51990a1cdf1a.jpg";